import { SVGS } from '@zonofi/zono-money-design-system';
import { PaymentStatusEnum } from '@zonofi/zono-money-store';

export const getInvoiceIcon = (status: PaymentStatusEnum): string => {
  switch (status) {
    case PaymentStatusEnum.PAID:
    case PaymentStatusEnum.SENT:
      return SVGS.Payment;
    case PaymentStatusEnum.CONFIRMED:
      return SVGS.PaymentConfirmed;
    default:
      return SVGS.Payment;
  }
};
